import React, {Component} from 'react';
import {connector, store} from '../store';

class ButtonPlay extends Component {

  // CSS Properties hard-coded to .circle.animate for <IE11 support
  render() {
    return (
      <svg className="button-play" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg" width="75" height="75">
        <circle className="circle" cx="17" cy="17" r="15" />
        {this.props.animate &&
        <circle className="circle animate" cx="17" cy="17" r="15" transform="rotate(-90deg)" origin="center" strokeDasharray="100,100" />
        }
        <path className="triangle" d="M12 10 v13.6 l11.8 -7z"/>
      </svg>
    );
  }
}

export default connector(ButtonPlay);